import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-feed-config',
  templateUrl: 'feed-config.component.html'
})
export class FeedConfigComponent implements OnInit {
  @Input() item: any;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    if (!this.item.title) {
      this.item.title = { text: '', color: '#444444', size: 24, align: 'left' };
    }
    if (!this.item.subtitle) {
      this.item.subtitle = { text: '', color: '#444444', size: 16, align: 'left' };
    }
    if (typeof this.item.titlePaddingBottom === 'undefined') {
      this.item.titlePaddingBottom = 10;
    }
    if (!this.item.seeAllColor) {
      this.item.seeAllColor = '#444444';
    }
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  setAlign(element: any, align: string): void {
    element.align = align;
  }

}
